<script setup>
import { computed } from "vue";

const props = defineProps({
  icon: { type: String, default: null },
  title: { type: String, required: true },
  sub: { type: String, default: "" },
  iconBg: { type: String, default: "bg-muted" },
  iconColor: { type: String, default: "text-foreground" },
  plain: { type: Boolean, default: false },
  narrow: { type: Boolean, default: false },
});

const wrapClass = computed(() => [
  "w-8 h-8 flex items-center justify-center shrink-0",
  props.iconBg,
  props.iconColor,
]);

const headerClass = computed(() => {
  if (props.plain) {
    return props.narrow ? "px-4 pt-3.5 pb-1.5" : "px-5 pt-4 pb-2";
  }
  return "px-5 py-4 border-b border-border";
});

const bodyClass = computed(() => {
  if (props.plain) {
    return props.narrow ? "px-4 pt-1.5 pb-4" : "px-5 pt-2 pb-[18px]";
  }
  return "p-5";
});
</script>

<template>
  <section
    class="bg-card border border-border shadow-xs overflow-hidden mb-4"
    style="border-radius: var(--radius)"
  >
    <header :class="['flex items-center gap-2.5', headerClass]">
      <div
        v-if="!plain && icon"
        :class="wrapClass"
        style="border-radius: var(--radius)"
      >
        <SvgIcon :name="icon" style="width: 16px; height: 16px; fill: none" />
      </div>
      <div class="flex-1 min-w-0">
        <div
          class="text-[14.5px] font-semibold text-foreground tracking-tight m-0"
        >
          {{ title }}
        </div>
        <div v-if="sub" class="text-[12.5px] text-muted-foreground">
          {{ sub }}
        </div>
      </div>
      <div class="flex gap-1.5">
        <slot name="actions" />
      </div>
    </header>
    <div :class="bodyClass">
      <slot />
    </div>
  </section>
</template>
